<template>
  <div class="rm">
    <button ref="btn" type="button" class="rm__btn" aria-label="Acciones" aria-haspopup="menu" :aria-expanded="open" @click.stop="toggle">
      <span class="mdi mdi-dots-vertical"></span>
    </button>
    <teleport to="body">
      <div v-if="open" class="rm__menu" role="menu" :style="pos" @click.stop>
        <template v-for="(item, i) in items" :key="i">
          <div v-if="item.divider" class="rm__divider"></div>
          <button
            v-else
            type="button"
            role="menuitem"
            class="rm__item"
            :class="{ 'rm__item--danger': item.danger }"
            :disabled="item.disabled"
            :title="item.hint"
            @click="pick(item)"
          >
            <span v-if="item.icon" class="mdi" :class="item.icon"></span>
            {{ item.label }}
          </button>
        </template>
      </div>
    </teleport>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

defineProps({ items: { type: Array, required: true } })
const emit = defineEmits(['select'])

const open = ref(false)
const btn = ref(null)
const pos = ref({})

function toggle() {
  if (open.value) { open.value = false; return }
  const r = btn.value.getBoundingClientRect()
  const menuW = 250
  const left = Math.max(8, Math.min(window.innerWidth - menuW - 8, r.right - menuW))
  // Si no cabe hacia abajo, se abre hacia arriba.
  const spaceBelow = window.innerHeight - r.bottom
  pos.value = spaceBelow < 300
    ? { left: `${left}px`, bottom: `${window.innerHeight - r.top + 4}px`, width: `${menuW}px` }
    : { left: `${left}px`, top: `${r.bottom + 4}px`, width: `${menuW}px` }
  open.value = true
}

function pick(item) {
  open.value = false
  emit('select', item.key)
}

const close = () => { open.value = false }
function onKey(e) { if (e.key === 'Escape') close() }
onMounted(() => {
  window.addEventListener('click', close)
  window.addEventListener('scroll', close, true)
  window.addEventListener('resize', close)
  window.addEventListener('keydown', onKey)
})
onBeforeUnmount(() => {
  window.removeEventListener('click', close)
  window.removeEventListener('scroll', close, true)
  window.removeEventListener('resize', close)
  window.removeEventListener('keydown', onKey)
})
</script>

<style scoped>
.rm { display: inline-flex; }
.rm__btn { border: none; background: none; cursor: pointer; font-size: 20px; color: #64748b; display: flex; padding: 4px; border-radius: 6px; }
.rm__btn:hover { background: #eef1f6; color: #1e3a5f; }
.rm__menu {
  position: fixed; z-index: 10001; background: #fff; border: 1px solid #e2e8f0; border-radius: 10px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18); padding: 6px; display: flex; flex-direction: column;
}
.rm__item {
  display: flex; align-items: center; gap: 10px; width: 100%; padding: 8px 10px; border: none; background: none;
  border-radius: 6px; cursor: pointer; font: 400 13px Inter, sans-serif; color: #1e3a5f; text-align: left;
}
.rm__item .mdi { font-size: 17px; color: #64748b; }
.rm__item:hover:not(:disabled) { background: #f1f5f9; }
.rm__item:disabled { opacity: 0.45; cursor: default; }
.rm__item--danger, .rm__item--danger .mdi { color: #e84545; }
.rm__divider { height: 1px; background: #eef1f6; margin: 4px 2px; }
</style>